import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CheckParentComponent } from './check-parent.component';
import { CheckParentModalService } from './check-parent.service';
import { ModalModule } from 'ngx-bootstrap/modal';

import { LocalModule } from './local/local.module';
import { ForeignerModule } from './foreigner/foreigner.module';
import { InfoModule } from './info/info.module';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    LocalModule, ForeignerModule, InfoModule,
  ],
  declarations: [
    CheckParentComponent
  ],
  providers:[
    CheckParentModalService,
  ],
  entryComponents: [
    CheckParentComponent
  ],
})
export class CheckParentModule { }
